import { Sort } from './pagination.model';
import { UserByRoleContent } from './user.model';

export class RoleSearchCriteria {
  searchCriteria?: string;
  page: number;
  size: number;
}

export class RoleContent {
  id: string;
  no: string;
  code: string;
  name: string;
  isPredefined: boolean;
  numOfUser: number;
  updatedBy: string;
  lastUpdated: string;
  notAllowDelete: boolean;
  departmentCode: string;
  departmentNameTh: string;
  departmentNameEn: string;
  isAnyDepartment: boolean;
  version: number;
}

export class RoleListResponse {
  content: RoleContent[];
  totalElements: number;
  totalPages: number;
  last: boolean;
  page: number;
  size: number;
  number: number;
  sort: Sort;
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

export interface RoleMasterResponse {
  id: string;
  version: number;
  sortingNo: number;
  name: string;
  code: string;
  enable: boolean;
  expand?: boolean;
  features?: Feature[];
  featureGroups?: FeatureGroup[];
}

export interface FeatureGroup {
  group?: string | null;
  groupName?: string | null;
  features: Feature[];
}

export interface Feature {
  coApplications?: string[];
  code?: string;
  name: string;
  group?: string;
  groupName?: string;
  moduleName?: string | null;
  enable: boolean;
  isOrdinalSortingPermissions?: boolean | null;
  permissions: PermissionGroup[];
}

export interface PermissionGroup {
  group?: string;
  groupName?: string | null;
  groupSortingNo?: number | null;
  items: Permission[];
}

export enum SectionType {
  HEADER = 'HEADER',
  FEATURE_HEADER = 'FEATURE_HEADER',
  SUB_HEADER = 'SUB_HEADER'
}

export enum Action {
  Manage = 'Manage',
  Approve = 'Approve',
  View = 'View'
}

export interface Permission {
  code: string;
  name: string;
  enable: boolean;
  section?: string;
  displayName?: string;
  action?: Action;
  sectionType?: SectionType;
  pdpaSensitive?: boolean;
  selected?: boolean | false;
  applications?: string;
}

export interface RoleCreated {
  name: string;
  departmentCode?: string;
  isAnyDepartment: boolean;
  isPredefined: boolean;
  permissions: PermissionCreated[];
  applications: string[];
}

export interface PermissionCreated {
  code: string;
  name: string;
  enable: boolean;
}

export interface RoleCreatedSuccessResponse {
  name: string;
  isPredefined: boolean;
  permissions: PermissionCreated[];
}

export interface RoleErrorResponse {
  duplicateName: string;
  code: string;
  message: string;
}

export interface RoleViewResponse {
  id: string;
  version: number;
  no: string;
  name: string;
  code: string;
  applications: string[];
  isPredefined: boolean;
  permissions: Permission[];
  createdDate?: string;
  createdBy?: string;
  lastModifiedDate?: string;
  lastModifiedBy?: string;
  notAllowDelete: boolean;
  departmentCode: string;
  departmentNameTh: string;
  departmentNameEn: string;
  isAnyDepartment: boolean;
}

export interface RoleEdit {
  id: string;
  version: number;
  no: string;
  name: string;
  departmentCode?: string;
  isAnyDepartment: boolean;
  code: string;
  applications: string[];
  isPredefined: boolean;
  permissions: Permission[];
}

export class UserByRoleContentList {
  page: number;
  size: number;
  totalElements: number;
  first: boolean;
  numberOfElements: number;
  totalPages: number;
  hasContent: boolean;
  last: boolean;
  empty: boolean;
  content: UserByRoleContent[];
}
